import type { TFunction } from 'i18next'
import { createErrorMapRule } from '../utils/create-rule.ts'

export const tooBigRule = (t: TFunction<'validation'>) =>
  createErrorMapRule('too_big', t, (issue, ctx, t) => {
    let count = 1
    switch (issue.type) {
      case 'array':
        count = ctx.data.length
        break
      case 'string':
        count = ctx.data.length
        break
      case 'set':
        count = ctx.data.size
        break
      default:
        count = 1
    }

    return {
      message: t(`${issue.type}.max`, {
        ...issue,
        context: issue.inclusive ? 'inclusive' : 'exclusive',
        count,
      }),
    }
  })
